var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vx-card",
        { staticClass: "mb-4" },
        [
          _c(
            "div",
            {
              staticClass:
                "flex justify-between items-start flex-wrap gap-2 mb-2",
            },
            [
              _c("div", [
                _c("h4", { staticClass: "mb-0" }, [
                  _vm._v(
                    _vm._s(
                      _vm.isEditMode
                        ? _vm.model.name || _vm.$t("lesson.title")
                        : _vm.$t("catalog.lesson.new_title")
                    )
                  ),
                ]),
                _c("small", { staticClass: "text-muted" }, [
                  _vm._v(_vm._s(_vm.$t("catalog.lesson.subtitle"))),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "d-flex", staticStyle: { gap: ".5rem" } },
                [
                  _vm.lessonId && _vm.model.ticket_enabled
                    ? _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: "tickets.grid",
                              expression: "'tickets.grid'",
                            },
                          ],
                          attrs: { variant: "outline-primary", size: "sm" },
                          on: {
                            click: function ($event) {
                              return _vm.$router.push(
                                "/ingressos/checkin/lesson/" + _vm.lessonId
                              )
                            },
                          },
                        },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-50",
                            attrs: { icon: "CheckSquareIcon" },
                          }),
                          _c("span", { staticClass: "align-middle" }, [
                            _vm._v(_vm._s(_vm.$t("catalog.ticket.panel"))),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.lessonId
                    ? _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: "lessons.show",
                              expression: "'lessons.show'",
                            },
                          ],
                          attrs: { variant: "outline-primary", size: "sm" },
                          on: {
                            click: function ($event) {
                              return _vm.$router.push(
                                "/lessons/" + _vm.lessonId + "/agenda"
                              )
                            },
                          },
                        },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-50",
                            attrs: { icon: "CalendarIcon" },
                          }),
                          _c("span", { staticClass: "align-middle" }, [
                            _vm._v(_vm._s(_vm.$t("lesson.agenda.title"))),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
          _c(
            "wizard-shell",
            {
              attrs: {
                steps: _vm.steps,
                current: _vm.currentStep,
                "done-keys": _vm.doneKeys,
                "free-navigation": _vm.isEditMode,
                "next-disabled": _vm.nextDisabled,
                busy: _vm.busy,
              },
              on: { prev: _vm.goPrev, next: _vm.goNext, goto: _vm.goToStep },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep === "sobre",
                      expression: "currentStep === 'sobre'",
                    },
                  ],
                },
                [
                  _c("validation-observer", {
                    ref: "validator",
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var valid = ref.valid
                          return [
                            _c(
                              "b-form",
                              {
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                  },
                                },
                              },
                              [
                                _c(
                                  "b-form-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "12", md: "6" } },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t("lesson.name"),
                                            rules: "required",
                                            mode: "lazy",
                                            slim: "",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (
                                                  validationContext
                                                ) {
                                                  return [
                                                    _c(
                                                      "b-form-group",
                                                      {
                                                        attrs: {
                                                          label:
                                                            _vm.$t(
                                                              "lesson.name"
                                                            ),
                                                          "label-for": "name",
                                                        },
                                                      },
                                                      [
                                                        _c("b-form-input", {
                                                          staticClass:
                                                            "required",
                                                          attrs: {
                                                            id: "name",
                                                            type: "text",
                                                            placeholder: _vm.$t(
                                                              "catalog.lesson.name_placeholder"
                                                            ),
                                                            state:
                                                              _vm.getValidationState(
                                                                validationContext
                                                              ),
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.model.name,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.model,
                                                                "name",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "model.name",
                                                          },
                                                        }),
                                                        _c(
                                                          "b-form-invalid-feedback",
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                validationContext
                                                                  .errors[0]
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "12", md: "6" } },
                                      [
                                        _c("validation-provider", {
                                          ref: "modalityProvider",
                                          attrs: {
                                            name: _vm.$t("modality.label"),
                                            rules: "required",
                                            mode: "lazy",
                                            slim: "",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (
                                                  validationContext
                                                ) {
                                                  return [
                                                    _c(
                                                      "b-form-group",
                                                      {
                                                        attrs: {
                                                          "label-for":
                                                            "modality",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "select-suggestion",
                                                          {
                                                            ref: "select_modality",
                                                            staticClass:
                                                              "flex-grow required",
                                                            attrs: {
                                                              max: 20,
                                                              column: "name",
                                                              model: "Modality",
                                                              label:
                                                                _vm.$t(
                                                                  "modality.label"
                                                                ),
                                                              itemTextFormat:
                                                                function (
                                                                  item
                                                                ) {
                                                                  return (
                                                                    "" +
                                                                    item.name
                                                                  )
                                                                },
                                                              isDisabled:
                                                                _vm.isEditMode,
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.modalitySelected,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.modalitySelected =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "modalitySelected",
                                                            },
                                                          }
                                                        ),
                                                        _c(
                                                          "small",
                                                          {
                                                            staticClass:
                                                              "text-muted d-block",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "catalog.lesson.modality_hint"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "small",
                                                          {
                                                            staticClass:
                                                              "text-danger",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                validationContext
                                                                  .errors[0]
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "12" } },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "Pessoa Jurídica",
                                            rules: "required",
                                            slim: "",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (
                                                  validationContext
                                                ) {
                                                  return [
                                                    _c("select-suggestion", {
                                                      attrs: {
                                                        id: "legal_entity_id",
                                                        column:
                                                          "company_name,trading_name,cnpj",
                                                        model: "LegalEntity",
                                                        label:
                                                          _vm.pessoaJuridicaLocked
                                                            ? "Vendedor"
                                                            : "Pessoa Jurídica",
                                                        appendClearOption: false,
                                                        placeholderText:
                                                          _vm.pessoaJuridicaLocked
                                                            ? ""
                                                            : "Digite o nome do estabelecimento",
                                                        itemTextFormat:
                                                          _vm.legalEntityItemTextFormat,
                                                        isDisabled:
                                                          _vm.pessoaJuridicaLocked,
                                                        required: true,
                                                      },
                                                      model: {
                                                        value: _vm.legalEntity,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.legalEntity = $$v
                                                        },
                                                        expression:
                                                          "legalEntity",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            validationContext
                                                              .errors[0]
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-row",
                                  { staticClass: "mt-1" },
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "12" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t("lesson.type"),
                                              "label-class": "required",
                                            },
                                          },
                                          [
                                            _c("choice-cards", {
                                              attrs: {
                                                options: _vm.lessonTypeCards,
                                                value: _vm.lessonType,
                                                disabled: _vm.isEditMode,
                                              },
                                              on: {
                                                input: _vm.onChangeLessonType,
                                              },
                                            }),
                                            _vm.isEditMode
                                              ? _c(
                                                  "small",
                                                  {
                                                    staticClass:
                                                      "text-muted d-block mt-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "catalog.lesson.type_locked_hint"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            !_vm.lessonType
                                              ? _c(
                                                  "small",
                                                  {
                                                    staticClass:
                                                      "text-warning d-block mt-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "catalog.lesson.type_required"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "12" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "catalog.lesson.sales_mode"
                                              ),
                                            },
                                          },
                                          [
                                            _c("choice-cards", {
                                              attrs: {
                                                options: _vm.salesModeCards,
                                                value: _vm.planOnly
                                                  ? "PLAN"
                                                  : "OPEN",
                                              },
                                              on: {
                                                input: _vm.onChangeSalesMode,
                                              },
                                            }),
                                            _c(
                                              "small",
                                              {
                                                staticClass:
                                                  "text-muted d-block mt-1",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "catalog.lesson.sales_mode_hint"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.lessonType === "SGL"
                                  ? _c(
                                      "b-form-row",
                                      [
                                        _c(
                                          "b-col",
                                          { attrs: { cols: "auto" } },
                                          [
                                            _c("validation-provider", {
                                              attrs: {
                                                name: _vm.$t(
                                                  "lesson.event_date"
                                                ),
                                                rules: "required",
                                                mode: "lazy",
                                                slim: "",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (
                                                      validationContext
                                                    ) {
                                                      return [
                                                        _c(
                                                          "b-form-group",
                                                          {
                                                            attrs: {
                                                              label:
                                                                _vm.$t(
                                                                  "lesson.event_date"
                                                                ),
                                                              "label-for":
                                                                "event_date",
                                                            },
                                                          },
                                                          [
                                                            _c("b-form-input", {
                                                              staticClass:
                                                                "required",
                                                              attrs: {
                                                                id: "event_date",
                                                                type: "date",
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.singleEventDate,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.singleEventDate =
                                                                      $$v
                                                                  },
                                                                expression:
                                                                  "singleEventDate",
                                                              },
                                                            }),
                                                            _c(
                                                              "small",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    validationContext
                                                                      .errors[0]
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-col",
                                          { attrs: { cols: "auto" } },
                                          [
                                            _c("validation-provider", {
                                              attrs: {
                                                name: _vm.$t(
                                                  "lesson.start_time"
                                                ),
                                                rules: "required",
                                                mode: "lazy",
                                                slim: "",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (
                                                      validationContext
                                                    ) {
                                                      return [
                                                        _c(
                                                          "b-form-group",
                                                          {
                                                            attrs: {
                                                              label:
                                                                _vm.$t(
                                                                  "lesson.start_time"
                                                                ),
                                                              "label-for":
                                                                "single_event_start_time",
                                                            },
                                                          },
                                                          [
                                                            _c("b-form-input", {
                                                              staticClass:
                                                                "required",
                                                              attrs: {
                                                                id: "single_event_start_time",
                                                                type: "time",
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.singleEventStartTime,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.singleEventStartTime =
                                                                      $$v
                                                                  },
                                                                expression:
                                                                  "singleEventStartTime",
                                                              },
                                                            }),
                                                            _c(
                                                              "small",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    validationContext
                                                                      .errors[0]
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-col",
                                          { attrs: { cols: "auto" } },
                                          [
                                            _c("validation-provider", {
                                              attrs: {
                                                name: _vm.$t("lesson.end_time"),
                                                rules: "required",
                                                mode: "lazy",
                                                slim: "",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (
                                                      validationContext
                                                    ) {
                                                      return [
                                                        _c(
                                                          "b-form-group",
                                                          {
                                                            attrs: {
                                                              label:
                                                                _vm.$t(
                                                                  "lesson.end_time"
                                                                ),
                                                              "label-for":
                                                                "single_event_end_time",
                                                            },
                                                          },
                                                          [
                                                            _c("b-form-input", {
                                                              staticClass:
                                                                "required",
                                                              attrs: {
                                                                id: "single_event_end_time",
                                                                type: "time",
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.singleEventEndTime,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.singleEventEndTime =
                                                                      $$v
                                                                  },
                                                                expression:
                                                                  "singleEventEndTime",
                                                              },
                                                            }),
                                                            _c(
                                                              "small",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    validationContext
                                                                      .errors[0]
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.lessonType === "PKG"
                                  ? _c(
                                      "b-form-row",
                                      [
                                        _c(
                                          "b-col",
                                          { attrs: { cols: "auto" } },
                                          [
                                            _c("validation-provider", {
                                              attrs: {
                                                name: _vm.$t("lesson.quantity"),
                                                rules: "required|integer",
                                                mode: "lazy",
                                                slim: "",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (
                                                      validationContext
                                                    ) {
                                                      return [
                                                        _c(
                                                          "b-form-group",
                                                          {
                                                            attrs: {
                                                              label:
                                                                _vm.$t(
                                                                  "lesson.quantity"
                                                                ),
                                                              "label-for":
                                                                "quantity",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "b-input-group",
                                                              {
                                                                staticClass:
                                                                  "required",
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-input",
                                                                  {
                                                                    staticClass:
                                                                      "required",
                                                                    attrs: {
                                                                      id: "quantity",
                                                                      type: "number",
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .model
                                                                          .quantity,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.model,
                                                                            "quantity",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "model.quantity",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "small",
                                                              {
                                                                staticClass:
                                                                  "text-muted d-block",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "catalog.lesson.quantity_hint"
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "small",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    validationContext
                                                                      .errors[0]
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "b-form-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "auto" } },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t("lesson.duration"),
                                            rules: "required|integer",
                                            mode: "lazy",
                                            slim: "",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (
                                                  validationContext
                                                ) {
                                                  return [
                                                    _c(
                                                      "b-form-group",
                                                      {
                                                        attrs: {
                                                          label:
                                                            _vm.$t(
                                                              "lesson.duration"
                                                            ),
                                                          "label-for":
                                                            "duration",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "b-input-group",
                                                          {
                                                            staticClass:
                                                              "required",
                                                            attrs: {
                                                              append: "minutos",
                                                            },
                                                          },
                                                          [
                                                            _c("b-form-input", {
                                                              staticClass:
                                                                "required",
                                                              attrs: {
                                                                id: "duration",
                                                                type: "number",
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.model
                                                                    .duration,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.model,
                                                                      "duration",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "model.duration",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "small",
                                                          {
                                                            staticClass:
                                                              "text-danger",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                validationContext
                                                                  .errors[0]
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "auto" } },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t("lesson.max_student"),
                                            rules: "required|integer",
                                            mode: "lazy",
                                            slim: "",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (
                                                  validationContext
                                                ) {
                                                  return [
                                                    _c(
                                                      "b-form-group",
                                                      {
                                                        attrs: {
                                                          label:
                                                            _vm.$t(
                                                              "lesson.max_student"
                                                            ),
                                                          "label-for":
                                                            "max_student",
                                                        },
                                                      },
                                                      [
                                                        _c("b-form-input", {
                                                          staticClass:
                                                            "required",
                                                          attrs: {
                                                            id: "max_student",
                                                            type: "number",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.model
                                                                .max_student,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.model,
                                                                "max_student",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "model.max_student",
                                                          },
                                                        }),
                                                        _c(
                                                          "small",
                                                          {
                                                            staticClass:
                                                              "text-muted d-block",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "catalog.lesson.max_student_hint"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "small",
                                                          {
                                                            staticClass:
                                                              "text-danger",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                validationContext
                                                                  .errors[0]
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "12" } },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t("lesson.description"),
                                            rules: "required",
                                            mode: "lazy",
                                            slim: "",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (
                                                  validationContext
                                                ) {
                                                  return [
                                                    _c(
                                                      "b-form-group",
                                                      {
                                                        attrs: {
                                                          label:
                                                            _vm.$t(
                                                              "lesson.description"
                                                            ),
                                                          "label-for":
                                                            "description",
                                                        },
                                                      },
                                                      [
                                                        _c("b-form-textarea", {
                                                          staticClass:
                                                            "required",
                                                          attrs: {
                                                            id: "description",
                                                            rows: "3",
                                                            "max-rows": "6",
                                                            placeholder: _vm.$t(
                                                              "catalog.lesson.description_placeholder"
                                                            ),
                                                            state:
                                                              _vm.getValidationState(
                                                                validationContext
                                                              ),
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.model
                                                                .description,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.model,
                                                                "description",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "model.description",
                                                          },
                                                        }),
                                                        _c(
                                                          "small",
                                                          {
                                                            staticClass:
                                                              "text-muted d-block",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "catalog.lesson.description_hint"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "b-form-invalid-feedback",
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                validationContext
                                                                  .errors[0]
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "catalog-more-toggle",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        _vm.moreOptionsOpen =
                                          !_vm.moreOptionsOpen
                                      },
                                    },
                                  },
                                  [
                                    _c("feather-icon", {
                                      staticClass: "mr-50",
                                      attrs: {
                                        icon: _vm.moreOptionsOpen
                                          ? "ChevronDownIcon"
                                          : "ChevronRightIcon",
                                        svgClasses: "w-4 h-4",
                                      },
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("catalog.lesson.more_options")
                                        ) +
                                        " "
                                    ),
                                  ],
                                  1
                                ),
                                _vm.moreOptionsOpen
                                  ? _c(
                                      "b-form-row",
                                      { staticClass: "mt-1" },
                                      [
                                        _c(
                                          "b-col",
                                          { attrs: { cols: "12", md: "6" } },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  "label-for": "rental_space",
                                                },
                                              },
                                              [
                                                _c("select-suggestion", {
                                                  ref: "select_rental_space",
                                                  staticClass:
                                                    "flex-grow w-full",
                                                  attrs: {
                                                    max: 20,
                                                    column: "name",
                                                    model: "RentalSpace",
                                                    label: _vm.$t(
                                                      "lesson.rental_space"
                                                    ),
                                                    itemTextFormat: function (
                                                      item
                                                    ) {
                                                      return "" + item.name
                                                    },
                                                    appendClearOption: true,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.rentalSpaceSelected,
                                                    callback: function ($$v) {
                                                      _vm.rentalSpaceSelected =
                                                        $$v
                                                    },
                                                    expression:
                                                      "rentalSpaceSelected",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass:
                                                      "text-muted d-block",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "catalog.lesson.rental_space_hint"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-col",
                                          { attrs: { cols: "12", md: "6" } },
                                          [
                                            _c("validation-provider", {
                                              attrs: {
                                                name: _vm.$t(
                                                  "lesson.min_purchase_advance_hours"
                                                ),
                                                rules: "integer|min_value:0",
                                                mode: "lazy",
                                                slim: "",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (
                                                      validationContext
                                                    ) {
                                                      return [
                                                        _c(
                                                          "b-form-group",
                                                          {
                                                            attrs: {
                                                              label: _vm.$t(
                                                                "lesson.min_purchase_advance_hours"
                                                              ),
                                                              "label-for":
                                                                "min_purchase_advance_hours",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "b-input-group",
                                                              {
                                                                staticStyle: {
                                                                  "max-width":
                                                                    "12rem",
                                                                },
                                                                attrs: {
                                                                  append:
                                                                    "horas",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-input",
                                                                  {
                                                                    attrs: {
                                                                      id: "min_purchase_advance_hours",
                                                                      type: "number",
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .model
                                                                          .min_purchase_advance_hours,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.model,
                                                                            "min_purchase_advance_hours",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "model.min_purchase_advance_hours",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "small",
                                                              {
                                                                staticClass:
                                                                  "text-muted d-block",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "catalog.lesson.advance_hint"
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "small",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    validationContext
                                                                      .errors[0]
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c("hr", { staticClass: "my-2" }),
                                _c(
                                  "b-form-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "12" } },
                                      [
                                        _c(
                                          "b-form-checkbox",
                                          {
                                            attrs: { switch: "" },
                                            model: {
                                              value: _vm.model.ticket_enabled,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.model,
                                                  "ticket_enabled",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "model.ticket_enabled",
                                            },
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "catalog.ticket.enable"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "small",
                                          { staticClass: "text-muted d-block" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "catalog.ticket.enable_hint"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm.model.ticket_enabled
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mt-2",
                                            attrs: { cols: "12" },
                                          },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "catalog.ticket.type"
                                                  ),
                                                },
                                              },
                                              [
                                                _c("choice-cards", {
                                                  attrs: {
                                                    options:
                                                      _vm.ticketTypeCards,
                                                    value:
                                                      _vm.model.ticket_type,
                                                  },
                                                  on: {
                                                    input: function (value) {
                                                      _vm.model.ticket_type =
                                                        value
                                                    },
                                                  },
                                                }),
                                                !_vm.model.ticket_type
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-warning d-block mt-1",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "catalog.ticket.type_required"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                !valid
                                  ? _c("div", { staticClass: "mt-1" }, [
                                      _c(
                                        "small",
                                        { staticClass: "text-warning" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "catalog.wizard.fill_required"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep === "agenda",
                      expression: "currentStep === 'agenda'",
                    },
                  ],
                },
                [
                  _vm.lessonId
                    ? [
                        _vm.lessonType !== "SGL"
                          ? _c(
                              "div",
                              { staticClass: "mb-4" },
                              [
                                _c("available-schedule", {
                                  ref: "scheduleGrid",
                                  attrs: {
                                    serviceDelegate: _vm.service,
                                    entityId: _vm.lessonId,
                                    defaultCapacity: _vm.model.max_student,
                                    defaultDuration: _vm.model.duration,
                                  },
                                  on: {
                                    "dirty-change": function ($event) {
                                      _vm.scheduleDirty = $event
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _c(
                              "b-alert",
                              {
                                staticClass: "p-1 mb-2",
                                attrs: { show: "", variant: "info" },
                              },
                              [
                                _c("small", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "catalog.lesson.single_event_no_grid",
                                        { date: _vm.singleEventSummary }
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                        _c("h6", { staticClass: "mb-50" }, [
                          _vm._v(
                            _vm._s(_vm.$t("catalog.lesson.teachers_title"))
                          ),
                        ]),
                        _c(
                          "small",
                          { staticClass: "text-muted d-block mb-1" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("catalog.lesson.teachers_hint"))
                            ),
                          ]
                        ),
                        _c("Teacher", {
                          attrs: {
                            services: _vm.service,
                            lessonId: _vm.lessonId,
                          },
                        }),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep === "venda",
                      expression: "currentStep === 'venda'",
                    },
                  ],
                },
                [
                  _c(
                    "b-alert",
                    {
                      staticClass: "p-1 mb-2",
                      attrs: {
                        show: _vm.productLoadFailed,
                        variant: "warning",
                      },
                    },
                    [
                      _c("small", [
                        _vm._v(_vm._s(_vm.$t("catalog.sale.sale_unavailable"))),
                      ]),
                    ]
                  ),
                  _vm.productExists
                    ? _c(
                        "sale-step",
                        {
                          attrs: {
                            "product-id": _vm.product.id,
                            price: _vm.product.price,
                            description: _vm.product.description,
                            "how-works": _vm.product.how_works,
                            guidelines: _vm.product.guidelines,
                            files: _vm.productFiles,
                            "multi-sale": _vm.productMultiSale,
                          },
                          on: {
                            "update:price": function ($event) {
                              return _vm.$set(_vm.product, "price", $event)
                            },
                            "update:description": function ($event) {
                              return _vm.$set(
                                _vm.product,
                                "description",
                                $event
                              )
                            },
                            "update:howWorks": function ($event) {
                              return _vm.$set(_vm.product, "how_works", $event)
                            },
                            "update:how-works": function ($event) {
                              return _vm.$set(_vm.product, "how_works", $event)
                            },
                            "update:guidelines": function ($event) {
                              return _vm.$set(_vm.product, "guidelines", $event)
                            },
                            "file-uploaded": _vm.onProductFileUploaded,
                            "delete-file": _vm.deleteProductFile,
                          },
                        },
                        [
                          _vm.lessonId
                            ? _c("div", { staticClass: "sale-step-extra" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "catalog-more-toggle",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        _vm.couponsOpen = !_vm.couponsOpen
                                      },
                                    },
                                  },
                                  [
                                    _c("feather-icon", {
                                      staticClass: "mr-50",
                                      attrs: {
                                        icon: _vm.couponsOpen
                                          ? "ChevronDownIcon"
                                          : "ChevronRightIcon",
                                        svgClasses: "w-4 h-4",
                                      },
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "catalog.lesson.coupons_optional"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ],
                                  1
                                ),
                                _vm.couponsOpen
                                  ? _c(
                                      "div",
                                      { staticClass: "mt-1" },
                                      [
                                        _c(
                                          "b-form-row",
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "w-full flex items-end",
                                                attrs: { cols: "auto" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "w-full" },
                                                  [
                                                    _c("select-suggestion", {
                                                      ref: "select_coupon",
                                                      staticClass: "flex-grow",
                                                      attrs: {
                                                        max: 20,
                                                        column: "name",
                                                        model: "DiscountCoupon",
                                                        label: _vm.$t(
                                                          "discount_coupon.label"
                                                        ),
                                                        itemTextFormat:
                                                          function (item) {
                                                            return (
                                                              item.code +
                                                              " - " +
                                                              item.name
                                                            )
                                                          },
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.discountCouponSelected,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.discountCouponSelected =
                                                            $$v
                                                        },
                                                        expression:
                                                          "discountCouponSelected",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "ml-1" },
                                                  [
                                                    _vm.discountCouponSelected
                                                      ? _c(
                                                          "b-button",
                                                          {
                                                            attrs: {
                                                              variant:
                                                                "outline-primary",
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.addDiscountCoupon,
                                                            },
                                                          },
                                                          [
                                                            _c("feather-icon", {
                                                              staticClass:
                                                                "stroke-current",
                                                              attrs: {
                                                                icon: "PlusIcon",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "vs-table",
                                          {
                                            staticClass: "mt-2",
                                            attrs: {
                                              data: _vm.discountCouponList,
                                              "no-data-text":
                                                "Nenhum cupom vinculado",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (ref) {
                                                    var data = ref.data
                                                    return _vm._l(
                                                      data,
                                                      function (tr, indextr) {
                                                        return _c(
                                                          "vs-tr",
                                                          { key: indextr },
                                                          [
                                                            _c("vs-td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  data[indextr]
                                                                    .code
                                                                )
                                                              ),
                                                            ]),
                                                            _c("vs-td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  data[indextr]
                                                                    .name
                                                                )
                                                              ),
                                                            ]),
                                                            _c(
                                                              "vs-td",
                                                              [
                                                                _c(
                                                                  "feather-icon",
                                                                  {
                                                                    staticClass:
                                                                      "h-5 w-5 mr-1 stroke-current text-danger",
                                                                    staticStyle:
                                                                      {
                                                                        cursor:
                                                                          "pointer",
                                                                      },
                                                                    attrs: {
                                                                      icon: "Trash2Icon",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.deleteDiscountCoupon(
                                                                            data[
                                                                              indextr
                                                                            ]
                                                                          )
                                                                        },
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    )
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              2549363313
                                            ),
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "thead" },
                                              [
                                                _c("vs-th", [_vm._v("Código")]),
                                                _c("vs-th", [_vm._v("Cupom")]),
                                                _c("vs-th", [_vm._v("Ação")]),
                                              ],
                                              1
                                            ),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep === "revisar",
                      expression: "currentStep === 'revisar'",
                    },
                  ],
                },
                [
                  _c(
                    "b-alert",
                    {
                      staticClass: "p-1 mb-2",
                      attrs: {
                        show: _vm.isExpiredSingleEvent,
                        variant: "warning",
                      },
                    },
                    [
                      _c("small", [
                        _vm._v(
                          _vm._s(_vm.$t("catalog.lesson.expired_warning"))
                        ),
                      ]),
                    ]
                  ),
                  _c("review-step", {
                    attrs: {
                      summary: _vm.reviewSummary,
                      price: _vm.product.price,
                      published: _vm.productPublished,
                      blockers: _vm.publishBlockers,
                      "front-url": _vm.publishedFrontUrl,
                      busy: _vm.busy,
                      "no-sale": _vm.planOnly,
                      "price-step-key": "venda",
                    },
                    on: {
                      goto: _vm.goToStep,
                      publish: _vm.publish,
                      "save-draft": _vm.saveDraft,
                      unpublish: _vm.unpublish,
                      finish: _vm.finishPlanOnly,
                    },
                    scopedSlots: _vm._u(
                      [
                        _vm.planOnly
                          ? {
                              key: "status",
                              fn: function () {
                                return [
                                  _c(
                                    "b-alert",
                                    {
                                      staticClass: "p-1 mb-2",
                                      attrs: {
                                        show: _vm.coveringPlans.length > 0,
                                        variant: "success",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "flex items-start" },
                                        [
                                          _c("feather-icon", {
                                            staticClass: "mr-1 flex-shrink-0",
                                            attrs: { icon: "RepeatIcon" },
                                          }),
                                          _c("div", [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$tc(
                                                    "catalog.lesson.covered_by_plans",
                                                    _vm.coveringPlans.length,
                                                    {
                                                      count:
                                                        _vm.coveringPlans
                                                          .length,
                                                    }
                                                  )
                                                )
                                              ),
                                            ]),
                                            _c("small", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.coveringPlans
                                                    .map(function (p) {
                                                      return p.name
                                                    })
                                                    .join(" · ")
                                                )
                                              ),
                                            ]),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "b-alert",
                                    {
                                      staticClass: "p-1 mb-2",
                                      attrs: {
                                        show:
                                          _vm.coveringPlansLoaded &&
                                          _vm.coveringPlans.length === 0,
                                        variant: "warning",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "flex items-start" },
                                        [
                                          _c("feather-icon", {
                                            staticClass: "mr-1 flex-shrink-0",
                                            attrs: {
                                              icon: "AlertTriangleIcon",
                                            },
                                          }),
                                          _c("small", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "catalog.lesson.no_covering_plan"
                                                )
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            }
                          : null,
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }